import { GraphErrors } from './errors';

export type ReportErrorType = 'DEFAULT' | 'NO_SELECTION' | 'ALREADY_REPORTED';

export class ReportError extends GraphErrors {
  constructor(public readonly key: ReportErrorType = 'DEFAULT') {
    super(key);
    this.name = 'ReportError';
  }
}
